<ng-container *ngIf="link; else cardTemplate">
  <ng-container [ngSwitch]="link.type">
    <a
      *ngSwitchCase="linkTypes.ROUTER"
      class="card-container"
      [routerLink]="[link.url, { outlets: link.outlets ?? {} }]"
      [queryParamsHandling]="link.outlets ? 'preserve' : undefined"
    >
      <ng-container *ngTemplateOutlet="cardTemplate"></ng-container>
    </a>
    <a *ngSwitchCase="linkTypes.PROGRAMMATIC" class="card-container" (click)="linkAction($event)">
      <ng-container *ngTemplateOutlet="cardTemplate"></ng-container>
    </a>
    <a *ngSwitchCase="linkTypes.EXTERNAL" class="card-container" [href]="link.url" [target]="link.target">
      <ng-container *ngTemplateOutlet="cardTemplate"></ng-container>
    </a>
    <div *ngSwitchCase="linkTypes.NONE" class="card-container">
      <ng-container *ngTemplateOutlet="cardTemplate"></ng-container>
    </div>
  </ng-container>
</ng-container>

<ng-template #cardTemplate>
  <wb-card interactive [attr.variant]="darkTheme ? 'dark-grey' : null" [ngClass]="{ dark: darkTheme }">
    <figure>
      <mb-info *ngIf="embargoDates" type="danger">
        <div class="embargo-container">
          <div class="embargo-title">
            <div>
              <wb-icon name="bds/exclamation-mark-circle-outline/24"></wb-icon>
              <wb-text size="l" class="embargo-subline">
                {{ 'EMBARGO_CONFIRM_SUBLINE' | translate }}
              </wb-text>
            </div>
            <wb-tag *ngIf="tag" variant="secondary" theme="dark">
              <wb-icon *ngIf="tag.icon" [name]="tag.icon"></wb-icon>{{ tag.label | translate }}
            </wb-tag>
          </div>
          <wb-text size="m" static class="embargo-date" *ngFor="let embargoDate of embargoDates">
            {{ embargoDate }}
          </wb-text>
        </div>
      </mb-info>

      <div class="tags" *ngIf="tag && !embargoDates">
        <wb-tag [variant]="darkTheme ? 'secondary' : 'tertiary'" theme="light">
          <wb-icon *ngIf="tag.icon" [name]="tag.icon"></wb-icon>{{ tag.label | translate }}
        </wb-tag>

        <wb-text *ngIf="tag.assetCountLabel && assetCount" size="s" class="wb-tag-right">{{
          tag.assetCountLabel | translate: { count: assetCount }
        }}</wb-text>

        <wb-text *ngIf="videoDuration" size="s" class="wb-tag-right">{{ videoDuration | durationFormat }}</wb-text>
      </div>

      <ng-container
        *ngIf="assetType !== 'DOCUMENT' && assetType !== 'MEDIA_COLLECTION' && assetType !== 'TECHNICAL_DATA'"
      >
        <mb-media
          *ngIf="media && !showImageFallback"
          [media]="media"
          [hoverplay]="true"
          [loop]="true"
          (imageError)="showImageFallback = true"
        ></mb-media>
        <wb-placeholder *ngIf="!media || showImageFallback" theme="dark"></wb-placeholder>
      </ng-container>
      <ng-container *ngIf="assetType === 'MEDIA_COLLECTION'">
        <img src="assets/img/media_collection_card.png" alt="Media Collection" />
      </ng-container>
      <ng-container *ngIf="assetType === 'DOCUMENT' || assetType === 'TECHNICAL_DATA'">
        <div class="document-img-placeholder">
          <wb-icon name="bds/document/24"></wb-icon>
        </div>
      </ng-container>
    </figure>

    <div class="card-content-wrapper">
      <div class="card-content">
        <div *ngIf="topline" class="topline">
          <wb-icon name="{{ toplineIcon }}"></wb-icon>
          <wb-text static size="s"> {{ topline }} </wb-text>
        </div>
        <wb-heading *ngIf="headline" size="xs">{{ headline }}</wb-heading>
        <wb-text size="l" *ngIf="text">{{ text }}</wb-text>
        <wb-text size="s" *ngIf="fuelLabel">{{ fuelLabel }}</wb-text>
      </div>

      <div class="card-footer">
        <ul class="meta-items" *ngIf="metaItems?.length">
          <li *ngFor="let item of metaItems" class="meta-item" [ngClass]="{ dark: darkTheme }">
            <wb-text size="s">{{ item.label | translate: item }}</wb-text>
          </li>
        </ul>
        <mb-action-button-group
          *ngIf="actions"
          [actions]="actions"
          [resource]="data"
          [darkTheme]="darkTheme"
        ></mb-action-button-group>
      </div>
    </div>
  </wb-card>
</ng-template>
